module.exports = __webpack_public_path__ + "static/media/Iphone2.png?v=4ecd1d7b";